export default "__VITE_ASSET__CDtuP5Rm__"